module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Y85H89/tc-custom/9781613732168.jpg?1701641264787",
      "alt": "This image is the cover for the book Peculiar People"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Peculiar People\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("These days hardly anyone remembers Augustus John Curthbert Hare (1834-1903). But in his prime, the late Victorian age, his name was on the lips of anyone who mattered. He was a travel writer, a storyteller and a memoirist of the first order, and his work is a fascinating record of a lost way of life amongst the strangest upper classes of English society. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Augustus Hare\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Augustus John Cuthbert Hare (1834-1903) was a Victorian writer who had clung, so to speak, to the edges of fame. He was born into the maddest of upper-class English families and survived one of the cruelest of childhoods to write monumental travel guides to the Continent and a six-volume autobiography, The Story of My Life. That autobiography is now extremely rare and growing rarer - since every day copies of it, even in libraries, crumble into dust. This is a one-volume condensation of this remarkable work, containing what the editors consider to be the highlights of Augustus Hare's harrowing tale, beginning with his birth, shortly following which his lackadaisical parents gave him to a relative, assuring her that if she wanted more children she should let them know, because they had others. ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chicago Review Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0